import { render } from "./IDCard.vue?vue&type=template&id=57e716f8&scoped=true"
import script from "./IDCard.vue?vue&type=script&lang=js"
export * from "./IDCard.vue?vue&type=script&lang=js"

import "./IDCard.vue?vue&type=style&index=0&id=57e716f8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e716f8"]])

export default __exports__